<template>
  <div class="home">
    <div class="banner min-container">
      <div class="container">
        <div class="banner_btn" @click="showDialog = true">
          <p>{{ $t('postpone.p2') }}</p>
        </div>
      </div>

      <!-- <swiper :options="swiperBannerOption">
        <swiper-slide v-for="(item, index) in 1" :key="index" style="height: 410px;">
          <div class="banner_img"></div>
        </swiper-slide>
      </swiper> -->
    </div>
    <div class="middle min-container" v-if="eventName === 'upcoming'">
      <events-home></events-home>
    </div>

    <el-dialog :visible.sync="showDialog" width="800px" :show-close="false" custom-class="showDialog">
      <div class="f-t-cancel" @click="showDialog = false">
      </div>
      <div class="pop">
        <div class="f-dialog">
          <div class="f-bg">
            <div class="f-content" v-bar>
              <div>
                <p class="home-color title">{{ $t('postpone.p11') }}</p>
                <p>{{ $t('postpone.p3') }}</p>
                <p>{{ $t('postpone.p4') }}</p>
                <p>{{ $t('postpone.p5') }}</p>
                <i18n path="postpone.p6" tag="p">
                  <template slot="link">
                    <a class="home-color" href="mailto:events@pppoker.net">events@pppoker.net</a>
                  </template>
                </i18n>
                <p>{{ $t('postpone.p7') }}</p>
                <p>{{ $t('postpone.p8') }}</p>
                <i18n path="postpone.p9" tag="p">
                  <template slot="link">
                    <a class="home-color" href="mailto:events@pppoker.net">events@pppoker.net</a>
                  </template>
                </i18n>
                <br>
                <p style="margin-bottom:0px;">{{ $t('postpone.p10') }}</p>
                <p>{{ $t('postpone.p12') }}</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css'
import {
// swiper,
// swiperSlide
} from 'vue-awesome-swiper'
import eventsHome from './eventsHome.vue'

export default {
  data () {
    return {
      showDialog: false,
      swiperBannerOption: {
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: true
        // },
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      eventName: 'upcoming',
      activeName: 'first',
      report: true,
      items: [{
        name: 'Day1',
        index: '1'
      },
      {
        name: 'Day2',
        index: '2'
      },
      {
        name: 'Day3',
        index: '3'
      },
      {
        name: 'Day4',
        index: '4'
      },
      {
        name: 'Day5',
        index: '5'
      },
      {
        name: 'Day6',
        index: '6'
      },
      {
        name: 'Final Day',
        index: '7'
      }
      ],
      report_index: '1',
      result_status: true,
      result_index: '1',
      schedule: [],
      result: {
        images: []
      },
      page: {
        now: 1,
        total: 1,
        per_num: 10
      }
    }
  },
  components: {
    // swiper,
    // swiperSlide,
    eventsHome
  },
  filters: {
    formatZero (data) {
      if (data === '0') {
        return '-'
      } else {
        return (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      }
    },
    formatZeroMobile (data) {
      if (data === '0') {
        return '-'
      } else {
        return (
          'PHP ' + (data || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        )
      }
    }
  },
  computed: {
    images: function () {
      let nums = {
        pc: {
          '1': ['1_01', '1_02', '1_03', '1_04', '1_05', '1_06', '1_07'],
          '2': ['2_01', '2_02', '2_03', '2_04', '2_05', '2_06', '2_07'],
          '3': [
            '3_01',
            '3_02',
            '3_03',
            '3_04',
            '3_05',
            '3_06',
            '3_07',
            '3_08',
            '3_08',
            '3_10'
          ],
          '4': ['4_01', '4_02', '4_03', '4_04', '4_05', '4_06', '4_07'],
          '5': ['5_01', '5_02', '5_03', '5_04', '5_05', '5_06', '5_07'],
          '6': ['6_01', '6_02', '6_03', '6_04', '6_05', '6_06', '6_07', '6_08'],
          '7': ['7_01', '7_02', '7_03', '7_04', '7_05', '7_06', '7_07']
        }
      }
      let desize = 'pc'

      return nums[desize][this.report_index].map(item => {
        return desize + '/' + this.report_index + '/images/' + item
      })
    }
  },
  methods: {
    getlist () {
      this.$axios
        .get('/poker-api/competition/schedules')
        .then(res => {
          console.log(res)
          if (res.status === 200 && res.data.code === 0) {
            this.schedule = res.data.data
            this.page.total = Math.ceil(
              res.data.data.length / this.page.per_num
            )
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    updateResultCon (id) {
      this.$axios
        .get('/poker-api/competition/result', {
          params: {
            id
          }
        })
        .then(res => {
          console.log(res)
          if (res.status === 200 && res.data.code === 0) {
            this.result = res.data.data.result || {
              images: []
            }
          } else {
            alert('network issue, Please try again later.')
          }
        })
        .catch(() => {
          alert('network issue, Please try again later.')
        })
    },
    changePage (page) {
      this.page.now += page
    },
    toReportCon (num) {
      this.report = false
      this.report_index = num.toString()
      document.querySelector('.middle').scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },
    toResultCon (id) {
      console.log(id)
      this.result_status = false
      this.result_index = id
      this.updateResultCon(id)
      document.querySelector('.middle').scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    }
  },
  created () {
    this.$store.commit('changeTab', '/events')
    // this.getlist()
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })

    setTimeout(() => {
      this.showDialog = true
    }, 1000)
  }
}
</script>

<style lang="scss">
  .showDialog {
    background: url('/official/static/img/ppwc/pop_ups_bg.png') no-repeat center top;
    background-size: 100% auto;
    border-radius: 0px;

    .el-dialog__body {
      padding-top: 20px;
      // background: url('/official/static/img/dialog/dialog-bg.jpg') no-repeat center top;
      // background-size: 100% auto;
      background-color: #ffffff;
    }

    .f-t-cancel {
      position: absolute;
      height: 35px;
      width: 35px;
      right: -16px;
      top: 0px;
      background-image: url("/official/static/img/dialog/dialog-close.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      z-index: 1;
    }

    .f-dialog {
      width: 100%;
      height: auto;
      position: relative;

      .f-bg {
        width: 100%;
      }

      .f-content {
        width: 100%;
        height: 360px;

        // overflow-x: hidden;
        // overflow-y: auto;

        .title {
          font-size: 30px;
          line-height: 34px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #077594;
        }
        .home-color {
          color: #077594;
        }

        p {
          word-break: keep-all;word-wrap: break-word;
          padding: 0px 36px 0px 20px;
          font-size: 16px;
          line-height: 26px;
          color: #727272;
          margin-bottom: 16px;
        }
      }
    }

    .vb>.vb-dragger {
      z-index: 5;
      width: 10px;
      right: 0;
    }

    .vb>.vb-dragger>.vb-dragger-styler {
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform: rotate3d(0, 0, 0, 0);
      transform: rotate3d(0, 0, 0, 0);
      -webkit-transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
      transition:
        background-color 100ms ease-out,
        margin 100ms ease-out,
        height 100ms ease-out;
      background-color: rgba(7, 117, 148, .1);
      margin: 5px 5px 5px 0;
      border-radius: 20px;
      height: calc(100% - 10px);
      display: block;
    }

    .vb.vb-scrolling-phantom>.vb-dragger>.vb-dragger-styler {
      background-color: rgba(7, 117, 148, .5);
    }

    .vb>.vb-dragger:hover>.vb-dragger-styler {
      background-color: rgba(7, 117, 148, .8);
      margin: 0px;
      height: 100%;
    }

    .vb.vb-dragging>.vb-dragger>.vb-dragger-styler {
      background-color: rgba(7, 117, 148, .8);
      margin: 0px;
      height: 100%;
    }

    .vb.vb-dragging-phantom>.vb-dragger>.vb-dragger-styler {
      background-color: rgba(7, 117, 148, .8);
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .home {
    position: relative;
    padding: 0;

    .banner {
      position: relative;
      height: 684px;
      z-index: 1;
      background-color: #000;
      background: url("/official/static/img/ppwc/banner.jpg") center center;
      background-repeat: no-repeat;

      .container {
        position: relative;
      }
      .banner_btn {
        position: absolute;
        width: 256px;
        height: 70px;
        right: 9px;
        top: 430px;
        background: url("/official/static/img/ppwc/banner_btn.png") center center;
        background-repeat: no-repeat;
        text-align: center;
        cursor: pointer;
        p {
          line-height: 53px;
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      // .banner_img {
      //   height: 410px;

      // }
      // /deep/.el-carousel__arrow {
      //   font-size: 30px;
      // }
      // .swiper-button-prev {
      //   background: url("/official/static/img/home/arrow_l.png") center center;
      //   background-size: 100%;
      // }
      // .swiper-button-next {
      //   background: url("/official/static/img/home/arrow_r.png") center center;
      //   background-size: 100%;
      // }
    }

    .top {
      position: relative;
      width: 100%;
      height: 57px;
      background-color: #000000;

      .top_title {
        font-size: 18px;
        color: #fff;

        a {
          cursor: pointer;
          line-height: 57px;
          color: #cccccc;
          margin: 0 20px;
        }

        a:nth-child(1) {
          margin-left: 0px;
        }

        .highlight {
          color: #077594;
        }
      }
    }

    .middle {
      // color: #fff;
      position: relative;
      background-color: #fff;
      background: url('/official/static/img/ppwc/bg.jpg') no-repeat center top;
      padding: 65px 0px 0px 0px;

      /deep/.el-tabs__item {
        color: #cccccc;
        font-size: 24px;
      }

      /deep/.el-tabs__nav-wrap.is-top {
        display: inline-block;
        width: auto;
      }

      /deep/.el-tabs__nav.is-top {
        transform: translateX(0%) !important;
        padding: 0 19px;
      }

      /deep/.el-tabs__item.is-top.is-active {
        color: #077594;
        font-weight: bold;
      }

      /deep/.el-tabs__nav-wrap::after {
        background-color: #cccccc;
      }

      /deep/.el-tabs__active-bar {
        background-color: #077594;
        padding-right: 40px;
        height: 4px;
        margin-bottom: -1px;
        // left: -10px;
      }

      /deep/.el-tabs__item {
        height: 50px;
      }

      .upcoming-content {
        line-height: 30px;
      }

      .first {
        video {
          width: 100%;
        }

        .per-header {
          font-size: 32px;
          text-align: left;
          margin: 0px;
          padding: 32px 0px;
        }

        .all_days_bg {
          background: url('/official/static/img/events/bg_g_middle.png') no-repeat center top;
          height: 1296px;
          margin-top: 40px;
          padding-top: 50px;
        }

        .all_days .row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 30px 0;

          .column {
            width: 31.5%;

            img {
              width: 100%;
              display: inline-block;
              cursor: pointer;
            }
          }
        }

        .final_day {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0px 0px 30px 0px;

          .column {
            width: 100%;

            img {
              width: 100%;
              display: inline-block;
              cursor: pointer;
            }
          }
        }

        .about_ppwc_bg {
          background: url('/official/static/img/events/bg_logo.jpg') no-repeat right top;
          width: 100%;
          // height: 1073px;
          padding: 0px;
          margin-top: -70px;
        }

        .con2 {
          text-align: left;
          margin: 10px 0px 50px 0px;

          p {
            font-size: 17px;
            line-height: 24px;
            margin-bottom: 10px;
          }

          img {
            margin-top: 30px;
            width: 100%;
          }
        }

        .report_con {
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          margin-top: 65px;
          min-height: 1000px;
          padding-bottom: 70px;

          .left {
            position: relative;
            display: inline-block;
            width: 224px;

            .left_item {
              width: 220px;
              height: 55px;
              // background-color: #242424;
              margin-bottom: 2px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              p {
                font-size: 15px;
                max-width: 100%;
              }
            }

            .highlight {
              background-color: #58b26d;
              color: #fff;
            }
          }

          .right {
            position: relative;
            width: 822px;
            display: inline-block;
            // background-color: #000;
            // background-color: #242424;
            min-height: 600px;
            padding: 50px 67px;

            img {
              width: 100%;
              display: block;
            }

            .more_detail {
              position: absolute;
              width: 164px;
              bottom: 85px;
              left: 50%;
              margin-left: -82px;
              display: block;
            }
          }
        }
      }

      .second {
        padding-bottom: 70px;

        .result_home {

          .el-table::before,
          .el-table {
            background-color: inherit;
            color: #727272;
            font-size: 16px;
            margin-top: 40px;
          }

          /deep/.el-table .el-button--success {
            background-color: #077594;
            border-color: #077594;
          }

          /deep/.el-table td,
          /deep/.el-table th.is-leaf {
            border-color: #bebebe;
          }

          /deep/.el-table th,
          /deep/.el-table tr {
            background-color: inherit;
          }

          /deep/.el-table th,
          /deep/.el-table tr {
            &:hover {
              background-color: inherit;
            }
          }

          /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
            background-color: inherit;
          }
        }

        .result_con {
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          margin-top: 50px;

          // min-height: 1000px;
          // padding-bottom: 65px;
          .left {
            position: relative;
            display: inline-block;
            width: 224px;

            .left_item {
              width: 220px;
              height: 55px;
              // background-color: #242424;
              margin-bottom: 2px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              p {
                font-size: 15px;
                max-width: 100%;
              }
            }

            .highlight {
              background-color: #58b26d;
              color: #fff;
            }
          }

          .right {
            position: relative;
            text-align: left;
            width: 868px;
            display: inline-block;
            padding: 52px 44px;

            h2.ui.header {
              font-size: 38px;
              margin: 0px;
            }

            img {
              max-width: 100%;
            }

            p {
              font-size: 18px;
              margin: 18px 0px;
            }

            .el-table::before,
            .el-table {
              background-color: inherit;
              font-size: 16px;
              margin-top: 40px;
            }

            /deep/.el-table .el-button--success {
              background-color: #077594;
              border-color: #077594;
            }

            /deep/.el-table td,
            /deep/.el-table th.is-leaf {
              border-color: #bebebe;
            }

            /deep/.el-table th,
            /deep/.el-table tr {
              background-color: inherit;
            }

            /deep/.el-table th,
            /deep/.el-table tr {
              &:hover {
                background-color: inherit;
              }
            }

            /deep/.el-table--enable-row-hover .el-table__body tr:hover>td {
              background-color: inherit;
            }

            /deep/p {
              color: #727272 !important;
            }
          }
        }
      }
    }
  }
</style>
